module.exports = __webpack_public_path__ + "img/key.51d909d7.png";